
    var riot = require('riot')
    //src: starling/src/tags/rapid-card-creator.html
riot.tag2('rapid-card-creator',
  '<div class="input" ref="main" contenteditable="true" onkeydown="{handleKeydown}" placeholder="Quickly add cards for your ideas..."></div> <button class="Button Button--Outlined Button--Round Button--Icon mrgn-l-8" type="button" onclick="{closeRapidFire}"> <svg class="Button__Icon"> <use xlink:href="#close-icon"></use> </svg> </button>',
  '',
  '', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

var _nodesUi = require('lib/nodes-ui');

var _appUi = require('lib/app-ui');

this.canvas = opts.canvas;
this.canvas.rapidCardCreatorTag = this;
this.focus = function () {
  _this.refs.main.focus();
};
var $window = $(window);

this.closeRapidFire = function (e) {
  _this.canvas.rapidFireActivated = false;
  _this.canvas.update();
  _this.refs.main.innerText = '';
};

this.handleKeydown = function (e) {
  e.stopPropagation();
  if (e.keyCode == _constants.KEY_CODES.ESCAPE) {
    if (_this.canvas.rapidFireActivated) {
      _this.canvas.rapidFireActivated = false;
      _this.canvas.update();
      _this.refs.main.innerText = '';
    }
  } else if (e.keyCode == _constants.KEY_CODES.ENTER && !e.shiftKey) {
    var title = _this.refs.main.innerText.trim();
    e.stopImmediatePropagation();
    e.preventDefault();
    _this.refs.main.innerText = '';
    var allNodes = _this.canvas.store.getNodes();

    var vw = $window.width();
    var vh = $window.height();

    var _appUI$viewportCoords = _appUi.appUI.viewportCoordsToMapCoords({ x: vw / 2, y: vh / 2 }),
        x = _appUI$viewportCoords.x,
        y = _appUI$viewportCoords.y;

    var nodeId = _this.canvas.store.addNode({ x: x, y: y, title: title });
    _this.canvas.nodesTag.update();
    var nodeTag = _this.canvas.nodeTags[nodeId];
    var node = _this.canvas.store.getNode(nodeTag.instance.id);

    nodeTag.discoverPosition();
    nodeTag.updateTopLevelNeighborsLite();

    var messages = [];

    var _nui$fixOverlaps = _nodesUi.nui.fixOverlaps({ nodeTag: nodeTag, allowedDirections: ['up'] }),
        prevNodePositions = _nui$fixOverlaps.prevNodePositions,
        nodePositions = _nui$fixOverlaps.nodePositions;

    if (nodePositions.length) {
      nodeTag.x = nodePositions.x;
      nodeTag.y = nodePositions.y;
      nodeTag.update();
      messages.push(_this.canvas.operation.messages.updateNodePositions({
        prevNodePositions: prevNodePositions,
        nodePositions: nodePositions,
        prevLinkAngles: [],
        linkAngles: []
      }));
    }

    messages.push(_this.canvas.operation.messages.addNode({
      node: node
    }));

    _this.canvas.operation.batchOperation({
      messages: messages,
      onFailure: function onFailure(err) {
        console.log('batchOperation failure: ' + err);
      }
    });

    _this.canvas.appFooterTag.updateStyle();
    _this.refs.main.focus();
    setTimeout(function () {
      return _this.refs.main.innerHTML = '';
    });
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('rapid-card-creator')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/rapid-card-creator.html
// module id = 624
// module chunks = 0